import React from "react";
import Info from "./Info";
import ViewProperty from "./ViewProperty";
import Services from "./Services";
import About from "./AboutUs";
import Counter from "./Counter";
import Footer from "./Footer";
import Social from "../../../pages/MenzillPublicPages/Authentication/Social";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { withRouter } from "react-router-dom";
import { AboutServicesBg } from "./indexElems";

const HomePage = ({ history, userData }) => (
  <>
    <Info />
    <ViewProperty history={history} userData={userData} />
    <AboutServicesBg>
      <About/>
      <Services />
    </AboutServicesBg>
    <Counter/>
    <Footer />
    <Social />
  </>
);

// export default HomePage;

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HomePage));
